import { Environment } from './environment';

export const environment: Environment = {
  // baseURL: 'https://prodatexpilot-be.zamia.be',
  baseURL: 'https://prodatex-prod-be.zamia.be',
  daccaBaseURL: 'https://dacca.zamia.be',
  appInsightsInstrumentationKey: 'e89607a7-d489-4f63-b823-6a543e6dac5e',
  networkHealthTimeout: 5000,
  maxImageHeight: 600,
  maxImageWidth: 1080,
  imageQuality: 50,
  oktaAuthorizeUrl: 'https://belfius.okta.com/oauth2/aus7fs1yljXQzYNDs417/v1/authorize',
  oktaClientId: '0oa3rrd5dcijn2jQl417', // prodatex-okta.zamia.be
  useOkta: false,
  oktaLogoutUrl: 'https://belfius.okta.com/login/signout'
};
